import { render, staticRenderFns } from "./lastLogs.vue?vue&type=template&id=2ea87fe2&scoped=true"
import script from "./lastLogs.vue?vue&type=script&lang=js"
export * from "./lastLogs.vue?vue&type=script&lang=js"
import style0 from "./lastLogs.vue?vue&type=style&index=0&id=2ea87fe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea87fe2",
  null
  
)

export default component.exports